import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const AxleConfig = withFacetContext(
    FacetName.axle_config,
    withFilterContext(FilterName.axle_config, SearchFiltersDropdown, {
        hideLabel: true,
        title: 'Axle config',
    })
)
